import React from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { Container } from "react-bootstrap";

const KIYGSchedule = () => {
return (
    <>
        <Breadcrumb
            pageName={KIYGSchedule}
            pageTitle={"Khelo India Youth Games 2025"}
            img_url={"img/kiyg25-banner.jpg"}
            mobile_banner={"img/kiyg25-mobile.jpg"}
        />
        <Container>
            <div>
                <br />
                <h1>कार्यक्रम</h1>
                <div style={{ overflow: "hidden", display: "inline-block" }}>
                    <img
                        src="img/khelo india 01.jpg"
                        alt="Schedule Placeholder"
                        style={{
                            maxWidth: "100%",
                            height: "auto",
                            margin: "20px 0",
                            transition: "transform 0.3s ease",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                        onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                    />
                </div>
            </div>
        </Container>
    </>
);
};

export default KIYGSchedule;
